import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.9 11.217 8 9.951l2.1 1.283-.55-2.4 1.85-1.6-2.433-.217L8 4.751 7.033 7 4.6 7.217l1.85 1.617-.55 2.383Zm-2.017 2.784 1.084-4.684-3.634-3.15 4.8-.416L8 1.334l1.867 4.417 4.8.416-3.634 3.15 1.084 4.684L8 11.517l-4.117 2.484Z"
    }, null, -1)
  ])))
}
export default { render: render }